import React, { useState } from 'react'
import { Winning } from './components/Winning/WinningCard'
import { Button } from 'app-v2/design-systems/components/inputs/button'
import { colors } from 'shared/assets/styles'
import { ConfirmChoiceModal } from './components/modals/ConfirmChoiceModal'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import type { Gain } from 'shared/store/tu-preferes-king/types'
import { Spacer } from 'app-v2/design-systems'
import { SPACING } from 'app-v2/design-tokens'
import styled from 'styled-components'
import { TPKColors } from '../colors'
import { breakpoints } from 'app/assets/styles'

export const Winnings = ({
    parent,
    child
}: {
    parent?: Gain,
    child?: Gain
}) => {
    const { tpkToken } = useParams()
    const [selected, select] = useState(undefined)
    const [open, setConfirmModal] = useState(false)
    const selectedWinning = selected && (selected === 'CHILD' ? child : parent)
    const intl = useIntl()

    return (
        <>
            <StyledWinningsContainer>
                <Winning
                    selected={selected && selected === 'CHILD'}
                    winning={child}
                    type={'CHILD'}
                    onClick={() => select('CHILD')}
                />
                <Winning
                    selected={selected && selected === 'PARENT'}
                    winning={parent}
                    type={'PARENT'}
                    onClick={() => select('PARENT')}
                />
            </StyledWinningsContainer>

            <Spacer />

            <Button
                onClick={() => setConfirmModal(true)}
                buttonColor={
                    !!selected ? colors.bbqBrown : TPKColors.disableBackground
                }
                labelColor={!!selected ? colors.white : TPKColors.disableText}
                fullLength>
                {intl.formatMessage({
                    id: 'tupreferesking.duel.confirm.cta'
                })}
            </Button>

            <Spacer />

            {selectedWinning && (
                <ConfirmChoiceModal
                    choice={selected}
                    selectedWinning={selectedWinning}
                    onClose={() => setConfirmModal(false)}
                    visible={open}
                    tpkToken={tpkToken}
                />
            )}
        </>
    )
}

const StyledWinningsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: relative;
    width: 100%;
    padding-top: 120px;
    gap: ${SPACING.S};

    @media (max-width: ${breakpoints.small}px) {
        padding-top: 60px;
        gap: ${SPACING.XS};
    }
`
